import * as actionTypes from "../../actions/BUAP/actionsTypes";

const inititalState = {
  updatestatus: 0,
};

const updateStatusReducer = (state = inititalState, action) => {
  switch (action.type) {
    case actionTypes.SETUPDATESTAUS:
      return {
        ...state,
        updatestatus: action.value,
      };
    default:
      return state;
  }
};

export default updateStatusReducer;
